import React, { ReactElement } from 'react';
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Pool } from 'modules/defi/components/Pool';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';

import { translation } from './translation';
import { useDeFiPools } from './useDeFiPools';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

export function DeFi(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  const pools = useDeFiPools();

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t(keys.title)}</div>

      <div>
        <div className={classes.header}>
          <div className={classes.cell1}>{t(keys.assets)}</div>

          <div className={classes.cell2}>{t(keys.protocol)}</div>

          <div className={classes.cell3}>{t(keys.network)}</div>
        </div>

        <div className={classes.pools}>
          {pools.map((pool, i) => (
            <Pool key={pool.id} data={pool} secondaryColor={i !== 0} />
          ))}
        </div>
      </div>
    </div>
  );
}

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: `calc(100vh - 257px)`,
    fontSize: 14,

    [theme.breakpoints.down('sm')]: {
      minHeight: 340,
    },
  },
  title: {
    fontWeight: 700,
    fontSize: 32,
    margin: theme.spacing(10, 0),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(0, 6, 3),
    color: alpha(theme.palette.secondary.contrastText, 0.5),
    fontSize: 12,

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cell1: {
    width: '40%',
  },
  cell2: {
    width: '30%',
  },
  cell3: {
    width: '15%',
  },
  pools: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));
